// extracted by mini-css-extract-plugin
export default {"container":"home_container__ZFw20","wrapper":"home_wrapper__4-g0u","card":"home_card__XaPqD"};